import { localize } from "render/context/InternationalizationContext";

export const Trans = {
  Button: localize({
    en_GB: "Scan data",
    sv_SE: "Scan data",
  }),
};
